import { useNavigate, useParams } from "react-router-dom"
import ApiConfig from "../api/ApiConfig"
import { PostCallWithErrorResponse, simpleGetCall } from "../api/ApiServices"
import CustomButton from "../components/customButton"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"


const reasons = ['Not Relevant', 'Got Another Job', 'Stopped Looking', 'Not A Good fit', 'Other', 'Don’t Wish To Say']
function NotInterested() {

    const navigate = useNavigate()

    const { code, id } = useParams()

    const [selectedReason, setSelectedReason] = useState('')

    const [companyDetails, setCompanyDetails] = useState({})

    const [isMarketNotIntrstd, setIsMarkedNotIntrstd] = useState(false)


    const getCompanyDetails = () => {

        simpleGetCall(ApiConfig.GET_COMAPNY_ABOUT_JOB + code).then((res) => {

            if (res?.succeded) {
                setCompanyDetails(res?.response)
            }

        })

    }

    const updateStatus = () => {

        let payload = {
            "userId": id,
            "jobcode": code,
            "isNotInterested": true,
            "reason": selectedReason
        }

        PostCallWithErrorResponse(ApiConfig.UPDATE_NOT_INTERESTED, payload).then((res) => {


            if (res?.json?.succeded) {
                toast.success('Update Successfully !')
                setIsMarkedNotIntrstd(true)

            }
        })
    }

    useEffect(() => {
        getCompanyDetails()
    }, [])

    return (
        <div className="p-4" style={{ backgroundColor: 'white' }} >
            {
                isMarketNotIntrstd ? <h6 className="mt-2" style={{ fontFamily: "Inter-Regular",fontSize:'18px',fontWeight:'bold' }}>
                    You have been marked Not interested .
                </h6> : <>
                    <h4 className="fw-bold">Not Interested </h4>
                    <h6 className="mt-2" style={{ fontFamily: "Inter-Regular" }}>The status of your Application to {companyDetails?.jobtitle} at {companyDetails?.companyname} will be marked as “Not Interested” and
                        you will not receive any more regular follow up communications regarding you application status. </h6>
                    <div className="mt-3">
                        <h5 className="fw-bold">Tell us why</h5>
                        <div className="d-flex flex-column mt-2">
                            {
                                reasons.map((reson, index) => {
                                    return <div className="form-check form-check-inline mb-0"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                        }}
                                        onClick={() => setSelectedReason(reson)}
                                    >
                                        <input
                                            type="radio"
                                            // id={fieldName}
                                            // name={fieldName}
                                            className="form-check-input"
                                            value="Yes"
                                            checked={reson === selectedReason}
                                            // onChange={handleInputChange}
                                            style={{ cursor: "pointer" }}
                                        />
                                        <label
                                            // htmlFor={fieldName}
                                            className="form-check-label mb-0 mt-1"
                                            style={{ fontFamily: "Inter-Regular" }}
                                        >
                                            {reson}
                                        </label>
                                    </div>
                                })
                            }

                        </div>
                        <h6 className="mt-3" style={{ fontFamily: "Inter-Regular" }}>
                            The Data provided so far will be available with the
                            company and in case the company wishes to contact you, they will use the data provided to contact you with any specific opportunity or query.
                        </h6>
                        <div className="m-3" style={{ marginLeft: '-10px' }}>
                            <CustomButton
                                style={{ width: '80px', marginLeft: '-20px' }}
                                title='Save'
                                handleClick={updateStatus}
                            />
                        </div>
                    </div>
                </>
            }
        </div >
    )
}

export default NotInterested